import { render, staticRenderFns } from "./main.vue?vue&type=template&id=a5d9cc4a&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5d9cc4a')) {
      api.createRecord('a5d9cc4a', component.options)
    } else {
      api.reload('a5d9cc4a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=a5d9cc4a&", function () {
      api.rerender('a5d9cc4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/child/main.vue"
export default component.exports